import { render, staticRenderFns } from "./customerSelect.vue?vue&type=template&id=6a6315fa&scoped=true"
import script from "./customerSelect.vue?vue&type=script&lang=js"
export * from "./customerSelect.vue?vue&type=script&lang=js"
import style0 from "./customerSelect.vue?vue&type=style&index=0&id=6a6315fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6315fa",
  null
  
)

export default component.exports